import api from './api';

export const getBrokers = () => api.get('/broker-connections/brokers');

export const getBrokerConnections = () => api.get('/broker-connections/');

export const connectBroker = (data) =>
  api.post('/broker-connections/connect', data);

export const refreshBrokerConnection = (connectionId) =>
  api.post(`/broker-connections/${connectionId}/refresh`);

export const deleteBrokerConnection = (connectionId) =>
  api.delete(`/broker-connections/${connectionId}`);

export const getPublicPricing = () => api.get('/public/pricing');

export const getPublicConfig = () => api.get('/public/config');

export const getSubscriptionCurrent = () =>
  api.get('/subscriptions/current');


export const verifySubscription = (sessionId) =>
  api.get(`/subscriptions/verify/${sessionId}`);

export const createSubscriptionCheckout = (data) =>
  api.post('/subscriptions/checkout', data);

export const createBillingPortal = (data = {}) =>
  api.post('/subscriptions/billing-portal', data);

export const getBacktestHistory = (params) =>
  api.get('/backtest/history', { params });

export const runBacktest = (data) => api.post('/backtest', data);
